import { JSMOverlayTemplate } from '@/components/signup/layouts/product-overlay-template.tsx';
import { SiteActivation } from '@/components/signup/site-activation/site-activation.tsx';

import { Headings } from '../components/headings.tsx';
import { YourPlanIncludesText } from '../components/sub-heading.tsx';
import { WelcomeBackText } from '../components/welcome-back-heading.tsx';

const ExistingUserContent = () => {
	return (
		<>
			<Headings main={<WelcomeBackText />} sub={<YourPlanIncludesText />} />
			<SiteActivation />
		</>
	);
};

export const ExistingUser = () => (
	<JSMOverlayTemplate size="sm">
		<ExistingUserContent />
	</JSMOverlayTemplate>
);
